import type { WorkspaceStoreStateType } from "./workspace.types";

export const initialWorkspaceState: WorkspaceStoreStateType = {
  spaceId: "",
};
